import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { usePwaInstall } from '../hooks/usePwaInstall';

function AndroidIcon() {
  return (
    <svg className="pwa-os-icon" viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="currentColor"
        d="M17.6 9.48l1.84-3.18a.5.5 0 0 0-.2-.7.5.5 0 0 0-.68.2l-1.86 3.22A7.3 7.3 0 0 0 12 7.5c-1.7 0-3.26.58-4.7 1.52L5.44 5.8a.5.5 0 0 0-.68-.2.5.5 0 0 0-.2.7L6.4 9.48C4.36 11.02 3 13.37 3 16v1h18v-1c0-2.63-1.36-4.98-3.4-6.52zM9 15.25a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5zm6 0a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5z"
      />
    </svg>
  );
}

function IosIcon() {
  return (
    <svg className="pwa-os-icon" viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="currentColor"
        d="M16.7 12.4c-.03-2.3 1.88-3.4 1.96-3.45-1.07-1.56-2.74-1.78-3.33-1.8-1.42-.14-2.77.83-3.49.83-.72 0-1.84-.81-3.03-.79-1.56.02-3 1.9-3.77 3.62-1.61 2.79-.41 6.92 1.15 9.18.77 1.11 1.68 2.35 2.88 2.3 1.16-.05 1.6-.74 3-.74s1.8.74 3.02.72c1.25-.02 2.04-1.13 2.8-2.25.88-1.28 1.24-2.52 1.26-2.58-.03-.01-2.42-.93-2.45-3.04zM14.6 5.9c.64-.77 1.07-1.85.95-2.92-1.02.04-2.25.68-2.98 1.54-.65.76-1.22 1.86-1.07 2.96 1.13.09 2.28-.57 3.1-1.58z"
      />
    </svg>
  );
}

function ShareIcon() {
  return (
    <svg className="pwa-share-icon" viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 3v12M8 7l4-4 4 4M5 14v5a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-5"
      />
    </svg>
  );
}

function IosSteps() {
  return (
    <>
      <p className="pwa-install-lead">
        Dodaj codzisiaj do ekranu początkowego w Safari:
      </p>
      <ol className="pwa-install-steps">
        <li>
          Na dole Safari dotknij <strong>Udostępnij</strong>{' '}
          <ShareIcon />
        </li>
        <li>
          Przewiń listę i wybierz <strong>Do ekranu głównego</strong> ➕
        </li>
        <li>
          Naciśnij <strong>Dodaj</strong>
        </li>
      </ol>
    </>
  );
}

function AndroidSteps() {
  return (
    <>
      <p className="pwa-install-lead">
        Dodaj codzisiaj do ekranu głównego w Chrome:
      </p>
      <ol className="pwa-install-steps">
        <li>
          Otwórz menu <strong>⋮</strong> w przeglądarce
        </li>
        <li>
          Kliknij <strong>Dodaj do ekranu głównego</strong>
        </li>
        <li>
          Naciśnij <strong>Dodaj</strong>
        </li>
      </ol>
    </>
  );
}

export default function InstallPrompt() {
  const { standalone, isIos, isAndroid, promptInstall } = usePwaInstall();
  const [showHelp, setShowHelp] = useState(false);

  if (standalone) return null;

  const onClick = async () => {
    const started = await promptInstall();
    if (!started) setShowHelp(true);
  };

  const helpBody = isIos ? (
    <IosSteps />
  ) : isAndroid ? (
    <AndroidSteps />
  ) : (
    <>
      <p>
        <AndroidIcon /> <strong>Android (Chrome)</strong>
      </p>
      <AndroidSteps />
      <p>
        <IosIcon /> <strong>iPhone / iPad (tylko Safari)</strong>
      </p>
      <IosSteps />
    </>
  );

  const help = showHelp
    ? createPortal(
        <div className="modal-overlay" onClick={() => setShowHelp(false)}>
          <div
            className="modal-content pwa-install-help"
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-labelledby="pwa-install-title"
          >
            <div className="event-detail-header">
              <h2 id="pwa-install-title">Dodaj do ekranu początkowego</h2>
              <button type="button" onClick={() => setShowHelp(false)} className="close-btn" aria-label="Zamknij">
                ×
              </button>
            </div>
            <div className="event-detail-body">{helpBody}</div>
          </div>
        </div>,
        document.body
      )
    : null;

  return (
    <>
      <button
        type="button"
        className="pwa-download-btn"
        onClick={onClick}
        title="Pobierz aplikację"
        aria-label="Pobierz aplikację"
      >
        <span className="pwa-download-icons">
          <AndroidIcon />
          <IosIcon />
        </span>
      </button>
      {help}
    </>
  );
}
